// LIST
export const FETCH_BUNDLES = "app/Bundles/FETCH_BUNDLES";
export const FETCH_BUNDLES_SUCCESS = "app/Bundles/FETCH_BUNDLES_SUCCESS";
export const FETCH_BUNDLES_FAILURE = "app/Bundles/FETCH_BUNDLES_FAILURE";

// GET VIEW DATA
export const GET_VIEW_DATA = "app/Bundles/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Bundles/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Bundles/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_BUNDLES = "app/Bundles/ADD_BUNDLES";
export const ADD_BUNDLES_SUCCESS = "app/Bundles/ADD_BUNDLES_SUCCESS";
export const ADD_BUNDLES_FAILURE = "app/Bundles/ADD_BUNDLES_FAILURE";
// EDIT
export const EDIT_BUNDLES = "app/Bundles/EDIT_BUNDLES";
export const EDIT_BUNDLES_SUCCESS = "app/Bundles/EDIT_BUNDLES_SUCCESS";
export const EDIT_BUNDLES_FAILURE = "app/Bundles/EDIT_BUNDLES_FAILURE";
// DELETE
export const DELETE_BUNDLES = "app/Bundles/DELETE_BUNDLES";
export const DELETE_BUNDLES_SUCCESS = "app/Bundles/DELETE_BUNDLES_SUCCESS";
export const DELETE_BUNDLES_FAILURE = "app/Bundles/DELETE_BUNDLES_FAILURE";

export const GET_SUBS = "app/Bundles/GET_SUBS";
export const GET_SUBS_SUCCESS = "app/Bundles/GET_SUBS_SUCCESS";
export const GET_SUBS_FAILURE = "app/Bundles/GET_SUBS_FAILURE";

export const ADD_SUB = "app/Bundles/ADD_SUB";
export const ADD_SUB_SUCCESS = "app/Bundles/ADD_SUB_SUCCESS";
export const ADD_SUB_FAILURE = "app/Bundles/ADD_SUB_FAILURE";
